import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enCommon from "./locales/en/common.json";
import enAuth from "./locales/en/auth.json";
import enPages from "./locales/en/pages.json";
import enEvents from "./locales/en/events.json";
import enQuota from "./locales/en/quota.json";
import enFootageUsage from "./locales/en/footageUsage.json";

import koCommon from "./locales/ko/common.json";
import koAuth from "./locales/ko/auth.json";
import koPages from "./locales/ko/pages.json";
import koEvents from "./locales/ko/events.json";
import koQuota from "./locales/ko/quota.json";
import koFootageUsage from "./locales/ko/footageUsage.json";

// Translation resources
const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    pages: enPages,
    events: enEvents,
    quota: enQuota,
    footageUsage: enFootageUsage,
  },
  ko: {
    common: koCommon,
    auth: koAuth,
    pages: koPages,
    events: koEvents,
    quota: koQuota,
    footageUsage: koFootageUsage,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "ko"],
    nonExplicitSupportedLngs: true, // Allow ko-KR to match ko, en-US to match en, etc.
    defaultNS: "common",
    ns: ["common", "auth", "pages", "events", "quota", "footageUsage"],

    detection: {
      // Priority order for language detection
      order: [
        "cookie", // 1. Cookie (synced with backend - highest priority for consistency)
        "localStorage", // 2. User preference (from dropdown)
        "navigator", // 3. Browser language
        "htmlTag", // 4. HTML lang attribute
      ],
      caches: ["localStorage", "cookie"],
      lookupLocalStorage: "i18nextLng",
      lookupCookie: "i18next",
      cookieOptions: {
        path: "/",
        sameSite: "lax",
        maxAge: 365 * 24 * 60 * 60, // 1 year
      },
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false, // Avoid suspense overhead
    },

    debug: import.meta.env.DEV,
  });

export default i18n;
